var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReacticon = function SvgReacticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 9.342a1.342 1.342 0 1 0 0-2.684 1.342 1.342 0 0 0 0 2.684Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M8 10.75c3.977 0 7.202-1.231 7.202-2.75S11.977 5.25 8 5.25C4.022 5.25.798 6.481.798 8S4.022 10.75 8 10.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M5.618 9.375c1.99 3.445 4.668 5.621 5.983 4.862 1.315-.76.77-4.167-1.22-7.612C8.393 3.18 5.714 1.004 4.4 1.763c-1.315.76-.77 4.167 1.22 7.612Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M5.618 6.625c-1.988 3.445-2.534 6.853-1.22 7.612 1.316.76 3.995-1.417 5.983-4.862 1.99-3.445 2.535-6.853 1.22-7.612-1.315-.76-3.994 1.417-5.983 4.862Z"
  })));
};
export default SvgReacticon;